var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`dplayer-wrapper ${_vm.type}`},[_c('div',{attrs:{"id":"dplayer"}}),_vm._t("cover",null,{"playEnd":_vm.loadError})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }